import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useKiosk } from "./KioskContext";
import { CampaignSlideView } from "./CampaignMedia";

export const HeroCampaign = ({ c, dir, go }) => {
  const { tx, t } = useKiosk();
  const q = c.model_slug ? `?model=${c.model_slug}` : "";
  return (
    <motion.section key={c.id} custom={dir} initial={{ opacity: 0, x: 40 * dir }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -40 * dir }}
      transition={{ duration: 0.45, ease: [0.2, 0.7, 0.2, 1] }} drag="x" dragConstraints={{ left: 0, right: 0 }} dragElastic={0.25}
      onDragEnd={(_, info) => { if (info.offset.x < -60) go(1); if (info.offset.x > 60) go(-1); }}
      className="flex min-h-0 flex-1 px-6 pb-3 pt-4 lg:px-24 lg:pt-14 pk:!px-6 pk:!pt-4" data-testid="hero-campaign">
      <CampaignSlideView media={c.media} kicker={t("campaignKicker")} title={tx(c.title)} body={tx(c.body)} className="min-h-0 flex-1 rounded-[32px]">
        <div className="mt-6 flex gap-3">
          {c.model_slug && <Link to={`/kiosk/model/${c.model_slug}`} className="btn-pill bg-white text-[#1D1D1F]" data-testid="hero-campaign-explore">{t("explore")}</Link>}
          <Link to={`/kiosk/book/test_ride${q}`} className="btn-pill btn-teal" data-testid="hero-campaign-book">{t("bookTestRide")}</Link>
        </div>
      </CampaignSlideView>
    </motion.section>
  );
};
